import s from "./activation.module.css";

const RING_R = 17;
const RING_C = 2 * Math.PI * RING_R;

/** Compact bottom strip for mobile tour — step info + circular progress. */
export default function MobileTourBar({
  stepIndex = 1,
  stepTotal = 1,
  subIndex = 1,
  subTotal = 1,
  kicker = "Быстрый старт",
  title,
  hint,
  isNavStep = false,
  actionHint = "",
  advanceBlock = "",
  hideLabel = "Скрыть",
  advanceLabel = "Далее",
  laterLabel = "Пройти позже",
  showAdvanceBtn = false,
  onHide,
  onAdvance,
  onNavSkip,
  onLater,
  sheetMode = false,
}) {
  const ratio = stepTotal ? Math.min(1, stepIndex / stepTotal) : 0;
  const ringOffset = RING_C * (1 - ratio);
  const bodyHint = isNavStep ? hint || actionHint : hint;

  return (
    <div
      className={[s.actMobileTourBar, sheetMode ? s.actMobileTourBar_sheet : ""]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-live="polite"
      aria-label={`${kicker}, шаг ${stepIndex} из ${stepTotal}`}
    >
      <div className={s.actMobileTourRing} aria-hidden>
        <svg viewBox="0 0 40 40">
          <circle className={s.actMobileTourRingTrack} cx="20" cy="20" r={RING_R} />
          <circle
            className={s.actMobileTourRingValue}
            cx="20"
            cy="20"
            r={RING_R}
            strokeDasharray={RING_C}
            strokeDashoffset={ringOffset}
          />
        </svg>
        <span className={s.actMobileTourRingLabel}>
          {stepIndex}/{stepTotal}
        </span>
      </div>

      <div className={s.actMobileTourMain}>
        <p className={s.actMobileTourKicker}>
          {kicker}
          {subTotal > 1 ? (
            <span className={s.actMobileTourSub}>
              {" "}
              · {subIndex}/{subTotal}
            </span>
          ) : null}
        </p>
        <p className={s.actMobileTourTitle}>{title}</p>
        {bodyHint ? <p className={s.actMobileTourHint}>{bodyHint}</p> : null}
        {advanceBlock ? (
          <p className={s.actMobileTourWarn} role="alert">
            {advanceBlock}
          </p>
        ) : null}

        {showAdvanceBtn || (isNavStep && onNavSkip) || onLater ? (
          <div className={s.actMobileTourFoot}>
            {showAdvanceBtn ? (
              <button
                type="button"
                className={s.actMobileTourPrimary}
                onClick={onAdvance}
              >
                {advanceLabel}
              </button>
            ) : null}
            {isNavStep && onNavSkip ? (
              <button
                type="button"
                className={s.actMobileTourGhost}
                onClick={onNavSkip}
              >
                Уже здесь
              </button>
            ) : null}
            {onLater ? (
              <button
                type="button"
                className={s.actMobileTourGhost}
                onClick={onLater}
              >
                {laterLabel}
              </button>
            ) : null}
          </div>
        ) : null}
      </div>

      <button
        type="button"
        className={s.actMobileTourClose}
        onClick={onHide}
        aria-label={hideLabel}
      >
        ×
      </button>
    </div>
  );
}

